/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InputAssignCafMemberToServiceRequest } from '../models';
// @ts-ignore
import type { InputFinalizeServiceRequest } from '../models';
// @ts-ignore
import type { InputLockServiceRequest } from '../models';
// @ts-ignore
import type { InputRefundOrMarkAsExpired } from '../models';
// @ts-ignore
import type { InputSetCafNoteInServiceRequestById } from '../models';
// @ts-ignore
import type { InputUnlockServiceRequest } from '../models';
// @ts-ignore
import type { ResponseSetCafNoteInServiceRequestById } from '../models';
// @ts-ignore
import type { ServiceRequest } from '../models';
// @ts-ignore
import type { SingleServiceRequest } from '../models';
/**
 * AdminServiceRequestApi - axios parameter creator
 * @export
 */
export const AdminServiceRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Get requested services | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [registeredBeforeDate] 
         * @param {string} [registeredAfterDate] 
         * @param {boolean} [_export] 
         * @param {boolean} [hasUserSendProduct] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServiceRequest: async (filter?: string, registeredBeforeDate?: string, registeredAfterDate?: string, _export?: boolean, hasUserSendProduct?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/serviceRequest/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (registeredBeforeDate !== undefined) {
                localVarQueryParameter['registeredBeforeDate'] = registeredBeforeDate;
            }

            if (registeredAfterDate !== undefined) {
                localVarQueryParameter['registeredAfterDate'] = registeredAfterDate;
            }

            if (_export !== undefined) {
                localVarQueryParameter['export'] = _export;
            }

            if (hasUserSendProduct !== undefined) {
                localVarQueryParameter['hasUserSendProduct'] = hasUserSendProduct;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DEPRECATED: Assign a caf member to a service request
         * @param {InputAssignCafMemberToServiceRequest} [inputAssignCafMemberToServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCafMemberToServiceRequest: async (inputAssignCafMemberToServiceRequest?: InputAssignCafMemberToServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/serviceRequest/assignCafMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputAssignCafMemberToServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary Edit a service request
         * @param {ServiceRequest} [serviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editServiceRequest: async (serviceRequest?: ServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/serviceRequest/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary Finalize a service request
         * @param {InputFinalizeServiceRequest} [inputFinalizeServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeServiceRequest: async (inputFinalizeServiceRequest?: InputFinalizeServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/serviceRequest/finalize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputFinalizeServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get a single service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminServiceRequestById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdminServiceRequestById', 'id', id)
            const localVarPath = `/admin/serviceRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lock service request
         * @param {InputLockServiceRequest} [inputLockServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockServiceRequest: async (inputLockServiceRequest?: InputLockServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/serviceRequest/lock-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputLockServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"Service\"] 
         * @summary Refund or mark as expired | Permission required: [\"update\", \"Service\"]
         * @param {InputRefundOrMarkAsExpired} [inputRefundOrMarkAsExpired] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundOrMarkAsExpired: async (inputRefundOrMarkAsExpired?: InputRefundOrMarkAsExpired, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/serviceRequest/refundOrExpired`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputRefundOrMarkAsExpired, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceDocumentStatus\"] 
         * @summary Set a caf note to a single service request | Permission required: [\"readOne\", \"ServiceDocumentStatus\"]
         * @param {number} id 
         * @param {InputSetCafNoteInServiceRequestById} [inputSetCafNoteInServiceRequestById] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCafNoteInServiceRequestById: async (id: number, inputSetCafNoteInServiceRequestById?: InputSetCafNoteInServiceRequestById, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setCafNoteInServiceRequestById', 'id', id)
            const localVarPath = `/admin/serviceRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputSetCafNoteInServiceRequestById, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlock service request
         * @param {InputUnlockServiceRequest} [inputUnlockServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockServiceRequest: async (inputUnlockServiceRequest?: InputUnlockServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/serviceRequest/lock-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputUnlockServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminServiceRequestApi - functional programming interface
 * @export
 */
export const AdminServiceRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminServiceRequestApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Get requested services | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [registeredBeforeDate] 
         * @param {string} [registeredAfterDate] 
         * @param {boolean} [_export] 
         * @param {boolean} [hasUserSendProduct] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allServiceRequest(filter?: string, registeredBeforeDate?: string, registeredAfterDate?: string, _export?: boolean, hasUserSendProduct?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allServiceRequest(filter, registeredBeforeDate, registeredAfterDate, _export, hasUserSendProduct, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestApi.allServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary DEPRECATED: Assign a caf member to a service request
         * @param {InputAssignCafMemberToServiceRequest} [inputAssignCafMemberToServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignCafMemberToServiceRequest(inputAssignCafMemberToServiceRequest?: InputAssignCafMemberToServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignCafMemberToServiceRequest(inputAssignCafMemberToServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestApi.assignCafMemberToServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary Edit a service request
         * @param {ServiceRequest} [serviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editServiceRequest(serviceRequest?: ServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editServiceRequest(serviceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestApi.editServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary Finalize a service request
         * @param {InputFinalizeServiceRequest} [inputFinalizeServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizeServiceRequest(inputFinalizeServiceRequest?: InputFinalizeServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizeServiceRequest(inputFinalizeServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestApi.finalizeServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get a single service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminServiceRequestById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminServiceRequestById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestApi.getAdminServiceRequestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lock service request
         * @param {InputLockServiceRequest} [inputLockServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockServiceRequest(inputLockServiceRequest?: InputLockServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockServiceRequest(inputLockServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestApi.lockServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"Service\"] 
         * @summary Refund or mark as expired | Permission required: [\"update\", \"Service\"]
         * @param {InputRefundOrMarkAsExpired} [inputRefundOrMarkAsExpired] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundOrMarkAsExpired(inputRefundOrMarkAsExpired?: InputRefundOrMarkAsExpired, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundOrMarkAsExpired(inputRefundOrMarkAsExpired, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestApi.refundOrMarkAsExpired']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceDocumentStatus\"] 
         * @summary Set a caf note to a single service request | Permission required: [\"readOne\", \"ServiceDocumentStatus\"]
         * @param {number} id 
         * @param {InputSetCafNoteInServiceRequestById} [inputSetCafNoteInServiceRequestById] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCafNoteInServiceRequestById(id: number, inputSetCafNoteInServiceRequestById?: InputSetCafNoteInServiceRequestById, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSetCafNoteInServiceRequestById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCafNoteInServiceRequestById(id, inputSetCafNoteInServiceRequestById, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestApi.setCafNoteInServiceRequestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unlock service request
         * @param {InputUnlockServiceRequest} [inputUnlockServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockServiceRequest(inputUnlockServiceRequest?: InputUnlockServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockServiceRequest(inputUnlockServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestApi.unlockServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminServiceRequestApi - factory interface
 * @export
 */
export const AdminServiceRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminServiceRequestApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Get requested services | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [registeredBeforeDate] 
         * @param {string} [registeredAfterDate] 
         * @param {boolean} [_export] 
         * @param {boolean} [hasUserSendProduct] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServiceRequest(filter?: string, registeredBeforeDate?: string, registeredAfterDate?: string, _export?: boolean, hasUserSendProduct?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequest>> {
            return localVarFp.allServiceRequest(filter, registeredBeforeDate, registeredAfterDate, _export, hasUserSendProduct, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DEPRECATED: Assign a caf member to a service request
         * @param {InputAssignCafMemberToServiceRequest} [inputAssignCafMemberToServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCafMemberToServiceRequest(inputAssignCafMemberToServiceRequest?: InputAssignCafMemberToServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.assignCafMemberToServiceRequest(inputAssignCafMemberToServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary Edit a service request
         * @param {ServiceRequest} [serviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editServiceRequest(serviceRequest?: ServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.editServiceRequest(serviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary Finalize a service request
         * @param {InputFinalizeServiceRequest} [inputFinalizeServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeServiceRequest(inputFinalizeServiceRequest?: InputFinalizeServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.finalizeServiceRequest(inputFinalizeServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get a single service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminServiceRequestById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<SingleServiceRequest> {
            return localVarFp.getAdminServiceRequestById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lock service request
         * @param {InputLockServiceRequest} [inputLockServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockServiceRequest(inputLockServiceRequest?: InputLockServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.lockServiceRequest(inputLockServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"Service\"] 
         * @summary Refund or mark as expired | Permission required: [\"update\", \"Service\"]
         * @param {InputRefundOrMarkAsExpired} [inputRefundOrMarkAsExpired] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundOrMarkAsExpired(inputRefundOrMarkAsExpired?: InputRefundOrMarkAsExpired, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.refundOrMarkAsExpired(inputRefundOrMarkAsExpired, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceDocumentStatus\"] 
         * @summary Set a caf note to a single service request | Permission required: [\"readOne\", \"ServiceDocumentStatus\"]
         * @param {number} id 
         * @param {InputSetCafNoteInServiceRequestById} [inputSetCafNoteInServiceRequestById] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCafNoteInServiceRequestById(id: number, inputSetCafNoteInServiceRequestById?: InputSetCafNoteInServiceRequestById, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSetCafNoteInServiceRequestById> {
            return localVarFp.setCafNoteInServiceRequestById(id, inputSetCafNoteInServiceRequestById, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlock service request
         * @param {InputUnlockServiceRequest} [inputUnlockServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockServiceRequest(inputUnlockServiceRequest?: InputUnlockServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.unlockServiceRequest(inputUnlockServiceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminServiceRequestApi - interface
 * @export
 * @interface AdminServiceRequestApi
 */
export interface AdminServiceRequestApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
     * @summary Get requested services | Permission required: [\"readAll\", \"ServiceRequest\"]
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {string} [registeredBeforeDate] 
     * @param {string} [registeredAfterDate] 
     * @param {boolean} [_export] 
     * @param {boolean} [hasUserSendProduct] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApiInterface
     */
    allServiceRequest(filter?: string, registeredBeforeDate?: string, registeredAfterDate?: string, _export?: boolean, hasUserSendProduct?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequest>>;

    /**
     * 
     * @summary DEPRECATED: Assign a caf member to a service request
     * @param {InputAssignCafMemberToServiceRequest} [inputAssignCafMemberToServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApiInterface
     */
    assignCafMemberToServiceRequest(inputAssignCafMemberToServiceRequest?: InputAssignCafMemberToServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

    /**
     *  **Permission required**: [\"update\", \"ServiceRequest\"] 
     * @summary Edit a service request
     * @param {ServiceRequest} [serviceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApiInterface
     */
    editServiceRequest(serviceRequest?: ServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

    /**
     *  **Permission required**: [\"update\", \"ServiceRequest\"] 
     * @summary Finalize a service request
     * @param {InputFinalizeServiceRequest} [inputFinalizeServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApiInterface
     */
    finalizeServiceRequest(inputFinalizeServiceRequest?: InputFinalizeServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Get a single service request | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApiInterface
     */
    getAdminServiceRequestById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<SingleServiceRequest>;

    /**
     * 
     * @summary Lock service request
     * @param {InputLockServiceRequest} [inputLockServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApiInterface
     */
    lockServiceRequest(inputLockServiceRequest?: InputLockServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

    /**
     *  **Permission required**: [\"update\", \"Service\"] 
     * @summary Refund or mark as expired | Permission required: [\"update\", \"Service\"]
     * @param {InputRefundOrMarkAsExpired} [inputRefundOrMarkAsExpired] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApiInterface
     */
    refundOrMarkAsExpired(inputRefundOrMarkAsExpired?: InputRefundOrMarkAsExpired, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

    /**
     *  **Permission required**: [\"readOne\", \"ServiceDocumentStatus\"] 
     * @summary Set a caf note to a single service request | Permission required: [\"readOne\", \"ServiceDocumentStatus\"]
     * @param {number} id 
     * @param {InputSetCafNoteInServiceRequestById} [inputSetCafNoteInServiceRequestById] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApiInterface
     */
    setCafNoteInServiceRequestById(id: number, inputSetCafNoteInServiceRequestById?: InputSetCafNoteInServiceRequestById, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSetCafNoteInServiceRequestById>;

    /**
     * 
     * @summary Unlock service request
     * @param {InputUnlockServiceRequest} [inputUnlockServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApiInterface
     */
    unlockServiceRequest(inputUnlockServiceRequest?: InputUnlockServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

}

/**
 * AdminServiceRequestApi - object-oriented interface
 * @export
 * @class AdminServiceRequestApi
 * @extends {BaseAPI}
 */
export class AdminServiceRequestApi extends BaseAPI implements AdminServiceRequestApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
     * @summary Get requested services | Permission required: [\"readAll\", \"ServiceRequest\"]
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {string} [registeredBeforeDate] 
     * @param {string} [registeredAfterDate] 
     * @param {boolean} [_export] 
     * @param {boolean} [hasUserSendProduct] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApi
     */
    public allServiceRequest(filter?: string, registeredBeforeDate?: string, registeredAfterDate?: string, _export?: boolean, hasUserSendProduct?: boolean, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestApiFp(this.configuration).allServiceRequest(filter, registeredBeforeDate, registeredAfterDate, _export, hasUserSendProduct, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DEPRECATED: Assign a caf member to a service request
     * @param {InputAssignCafMemberToServiceRequest} [inputAssignCafMemberToServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApi
     */
    public assignCafMemberToServiceRequest(inputAssignCafMemberToServiceRequest?: InputAssignCafMemberToServiceRequest, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestApiFp(this.configuration).assignCafMemberToServiceRequest(inputAssignCafMemberToServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"ServiceRequest\"] 
     * @summary Edit a service request
     * @param {ServiceRequest} [serviceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApi
     */
    public editServiceRequest(serviceRequest?: ServiceRequest, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestApiFp(this.configuration).editServiceRequest(serviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"ServiceRequest\"] 
     * @summary Finalize a service request
     * @param {InputFinalizeServiceRequest} [inputFinalizeServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApi
     */
    public finalizeServiceRequest(inputFinalizeServiceRequest?: InputFinalizeServiceRequest, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestApiFp(this.configuration).finalizeServiceRequest(inputFinalizeServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Get a single service request | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApi
     */
    public getAdminServiceRequestById(id: number, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestApiFp(this.configuration).getAdminServiceRequestById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lock service request
     * @param {InputLockServiceRequest} [inputLockServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApi
     */
    public lockServiceRequest(inputLockServiceRequest?: InputLockServiceRequest, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestApiFp(this.configuration).lockServiceRequest(inputLockServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"Service\"] 
     * @summary Refund or mark as expired | Permission required: [\"update\", \"Service\"]
     * @param {InputRefundOrMarkAsExpired} [inputRefundOrMarkAsExpired] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApi
     */
    public refundOrMarkAsExpired(inputRefundOrMarkAsExpired?: InputRefundOrMarkAsExpired, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestApiFp(this.configuration).refundOrMarkAsExpired(inputRefundOrMarkAsExpired, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"ServiceDocumentStatus\"] 
     * @summary Set a caf note to a single service request | Permission required: [\"readOne\", \"ServiceDocumentStatus\"]
     * @param {number} id 
     * @param {InputSetCafNoteInServiceRequestById} [inputSetCafNoteInServiceRequestById] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApi
     */
    public setCafNoteInServiceRequestById(id: number, inputSetCafNoteInServiceRequestById?: InputSetCafNoteInServiceRequestById, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestApiFp(this.configuration).setCafNoteInServiceRequestById(id, inputSetCafNoteInServiceRequestById, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlock service request
     * @param {InputUnlockServiceRequest} [inputUnlockServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestApi
     */
    public unlockServiceRequest(inputUnlockServiceRequest?: InputUnlockServiceRequest, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestApiFp(this.configuration).unlockServiceRequest(inputUnlockServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

